export default __webpack_public_path__ + "static/media/header.76e9d5c8.jpg";